import { format } from "date-fns";
import type { Task } from "../types";
export function installationDayTitle(task: Task, day?: Date) {
  if (!day) return task.text;
  const key = format(day, "yyyy-MM-dd"),
    first = key === task.installation_start,
    last = key === task.installation_end;
  const name = task.text.replace(/^Монтаж\s*/i, "");
  return first && last
    ? `Начало и конец монтажа ${name}`
    : first
      ? `Начало монтажа ${name}`
      : last
        ? `Конец монтажа ${name}`
        : task.text;
}
